import { render, staticRenderFns } from "./ListOfCompanies.vue?vue&type=template&id=82b0c4f0&scoped=true&"
import script from "./ListOfCompanies.vue?vue&type=script&lang=ts&"
export * from "./ListOfCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./ListOfCompanies.vue?vue&type=style&index=0&id=82b0c4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b0c4f0",
  null
  
)

export default component.exports